import styled from 'styled-components'

export const WrapperStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TitleStrong = styled.strong`
  font-weight: 700;
  font-size: 1rem;
  line-height: 1;
  margin-right: 1rem;
`

export const WrapperInteractions = styled.div`
  display: flex;
  margin-top: 1rem;
  gap: 0.5rem;
`

export const TextButtonEdit = styled.span`
  display: flex;
  gap: 0.3rem;
  align-items: center;
`
